import en from './lang/en'
import zh from './lang/zh_cn'
export default {
  en: en,
  'zh_cn': zh
}



// WEBPACK FOOTER //
// ./src/cdpBase/i18n/index.js